<template>
	<div class="np-group np-group-column np-flex-1">
		<div class="w-100 d-flex">
			<div class="text-center np-font-s np-color-primary-400"
				:style="{
					'width': percent.value + '%', 
					'max-width': '100%',
				}"
			>
				<span v-if="labelsVisible.min">{{ percent.value + '%' }}</span>
			</div>
			<div class="text-center np-flex-1 np-font-s np-color-primary-400"><span v-if="labelsVisible.max">{{ (100 - percent.value) + '%' }}</span></div>
		</div>	
		<div class="np-progressbar" :class="classes">
			<div class="np-progressbar-track" 
				:style="{
					'width': percent.value + '%', 
					'max-width': '100%',
				}" 
				:class="percent.status">
			</div>
		</div>    
		<div class="w-100 d-flex justify-content-between">
			<div class="np-font-s np-color-primary-400"><span v-if="scalesVisible.min">{{ min }}</span></div>
			<div class="np-font-s np-color-amber"><span v-if="scalesVisible.middle">{{ middle }}</span></div>
			<div class="np-font-s np-color-primary-400"><span v-if="scalesVisible.max">{{ max }}</span></div>
		</div>	    
	</div>
</template>
  
<script>
	export default {
		props: {
			min: {
				type: Number,
				default: 0,
			},
			max: {
				type: Number,
				default: 0,
			},
			current: {
				type: Number,
				default: 0,
			},
			classes: {
				type: String,
				default: ''
			},
			trackClass: {
				type: String,
				default: ''
			},
			color: {
				type: String,
				default: ''
			},
			labelsVisible: {
				type: Object,
				default: {
					min: false,
					max: false
				}
			},	
			scalesVisible: {
				type: Object,
				default: {
					min: false,
					max: false,
					middle: false
				}
			}
		},
		computed: {
			middle() {
				return Math.round( (this.max - this.min) / 2 )
			},
			percent() {
				const res = {
					status: 'np-progressbar-danger',
					value: 0
				}

				const all = this.max - this.min
				const value = this.max - this.current
		
				res.value = parseInt((value / all) * 100)

				if (res.value >= 50) {
					res.status = "np-progressbar-success"
				} else {
					if (res.value >= 25 && res.value < 50) {
						res.status = "np-progressbar-warning"
					}
				}

				if (this.color) {
					res.status = this.color
				}

				return res
			},
		}
	}
</script>
  
<style scoped>
  /* Ваши стили */
</style>